import { render } from "./WafDialog.vue?vue&type=template&id=0f581ca2&ts=true"
import script from "./WafDialog.vue?vue&type=script&lang=ts"
export * from "./WafDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__